import React, {Component} from "react";
import {MULTI_COLOR_SETS, QuickHelpButton} from "../prodect/ProsCommonUi"
import LoadingAnimation from "../components/LoadingAnimation";
import BasicButton from "../components/BasicButton";
import Checkbox from "../components/Checkbox";
import ToggleSwitch from "../components/ToggleSwitch";
import RadioButton from "../components/RadioButton";
import Spacer from "../components/Spacer";
import AccordionDropdown from "../components/AccordionDropdown";
import DropdownMenu from "../components/DropdownMenu";
import TextInput from "../components/TextInput";
import ProsSidebarTop from "../prodect/ProsSidebarTop";

export default class Styleguide extends Component {

    state = {
        isLoading: false,
        showCode: null,
        subpage: 'default'
    }

    renderMultiColorPalettes(){
        let all = []
        for (const [key, value] of Object.entries(MULTI_COLOR_SETS)){
            let chunk = value.map((color)=>{
                return <div key={color}
                    style={{backgroundColor: color}}
                    className={"padding"}
                >{color}</div>
            })
            all.push(<div key={key}
                className={"padding"}
            >
                <h3>{key}</h3>
                <div className={"element-set"}>
                    {chunk}
                </div>
            </div>)
        }
        return <div className={"slab"}>{all}</div>
    }

    renderContentOther(){
        return <>
            <h1>Icons and colors</h1>
            <h2>Multichoise color palettes</h2>
            {this.renderMultiColorPalettes()}
        </>
    }

    // async componentDidMount() {
    // }
    //
    // componentWillUnmount() {
    // }

    loadingScreen() {
        if (!this.state.loading) {
            return null
        }
        return <LoadingAnimation size={"lg"} color={"var(--color-light)"} mask />
    }

    renderHeader() {
        return <header className="page-header">
            <h1>Styleguide</h1>
            {this.state.showCode ? <p>{this.state.showCode}</p> : null}
            {/*<nav className={"btn-set"}>*/}
            {/*    {this.renderHeaderMainButton(PAGE_CUST_SETTINGS, "btn-icon-gear", "1", "Asetukset")}*/}
            {/*    {this.renderHeaderMainButton(PAGE_CUST_PG, "btn-icon-group", "2", "Käyttöoikeusryhmät")}*/}
            {/*    {this.renderHeaderMainButton(PAGE_CUST_USERS, "btn-icon-stats", "3", "Käyttötiedot")}*/}
            {/*</nav>*/}
        </header>
    }

    renderButtons(){
        let classes = [
            'primary',
            '2nd',
            '3rd',
            'none',
            'custom-text'
        ]
        let types = [
            'warning',
            'required',
            'prompt'
        ]
        return <>
            {classes.map((_class, _i)=>{
                let action =(_t)=>{
                    this.setState({
                        showCode: _t.outerHTML.toString()
                    })
                }
                let c = _i + 1
                return <React.Fragment key={"btns__" + c}>
                        <div className={"btn-set"}>
                            <BasicButton
                                btnClass={_class}
                                label={_class}
                                action={(evt)=> action(evt.target.parentNode)}
                                tag={1}
                            />
                            <BasicButton
                                btnClass={_class}
                                label={_class + " with icon"}
                                icon={"check"}
                                action={(evt)=> action(evt.target.parentNode)}
                                disabled
                                tag={123}
                            />
                            <BasicButton
                                btnClass={_class}
                                label={_class}
                                action={(evt)=> action(evt.target.parentNode)}
                                btnType={"locked"}
                            />
                            <BasicButton
                                btnClass={_class}
                                icon={"bin"}
                                action={(evt)=> action(evt.target.parentNode)}
                                btnType={"locked"}
                            />
                            <BasicButton
                                btnClass={_class}
                                label={_class + " with icon"}
                                icon={"check"}
                                action={(evt)=> action(evt.target.parentNode)}
                                btnType={"locked"}
                                tag={123}
                            />
                            <BasicButton
                                btnClass={_class}
                                label={_class + " icon right"}
                                icon={"check"}
                                iconPosition={"right"}
                                action={(evt)=> action(evt.target.parentNode)}
                                btnType={"locked"}
                            />
                            <BasicButton
                                btnClass={_class}
                                icon={"check"}
                                action={(evt)=> action(evt.target.parentNode)}
                                btnType={"prompt"}
                                disabled
                            />
                            <BasicButton
                                btnClass={_class}
                                icon={"check"}
                                loading={true}
                                action={(evt)=> action(evt.target.parentNode)}
                            />
                            <BasicButton
                                btnClass={_class}
                                label={_class + " loading"}
                                loading={true}
                                action={(evt)=> action(evt.target.parentNode)}
                            />
                            <BasicButton
                                btnClass={_class}
                                label={_class + " selected"}
                                selected={true}
                                action={(evt)=> action(evt.target.parentNode)}
                            />
                            <BasicButton
                                btnClass={_class}
                                icon={"calendar"}
                                label={_class + " disabled"}
                                disabled={true}
                                action={(evt)=> action(evt.target.parentNode)}
                            />
                            <BasicButton
                                btnClass={_class}
                                label={_class + " disabled"}
                                disabled={true}
                                action={(evt)=> action(evt.target.parentNode)}
                            />
                            {types.map((_type)=>{
                                return <BasicButton
                                    key={"btn__" + _type}
                                    btnClass={_class}
                                    label={_class + " " + _type}
                                    btnType={_type}
                                    action={(evt)=> action(evt.target.parentNode)}
                                />
                            })}
                    </div>
                    <Spacer />
                </React.Fragment>
            })}

            <div className={"element-set valign-center"}>
                <h3 className={"margin-0"}>Title text</h3>
                <QuickHelpButton />
            </div>
        </>
    }

    renderInputs(){
        return <div className={"grid-container grid-2"}>
            <div className={"selection-group selection-group-check"}>
                <Checkbox
                    text={"Not checked"}
                />
                <Checkbox
                    checked={true}
                    text={"Checked"}
                />
                <Checkbox
                    text={"Not checked disabled"}
                    disabled={true}
                />
                <Checkbox
                    checked={true}
                    text={"Checked disabled"}
                    disabled={true}
                />
            </div>
            <div className={"element-set-v"}>
                <ToggleSwitch
                    label={"Not checked"}
                    checked={false}
                    onChange={()=> {}}
                />
                <ToggleSwitch
                    label={"Checked"}
                    checked={true}
                    onChange={()=> {}}

                />
                <ToggleSwitch
                    label={"Not checked & disabled"}
                    checked={false}
                    onChange={()=> {}}
                    disabled={true}
                />
                <ToggleSwitch
                    label={"Checked & disabled"}
                    checked={true}
                    onChange={()=> {}}
                    disabled={true}
                />
            </div>
            <div className={"selection-group selection-group-radio"}>
                <RadioButton
                    checked={true}
                    text={"Checked"}
                />
                <RadioButton
                    checked={false}
                    text={"Not checked"}
                />
            </div>
            <div className={"selection-group-radio"}>
                <RadioButton
                    checked={true}
                    disabled={true}
                    text={"Checked & disabled"}
                />
                <RadioButton
                    checked={false}
                    disabled={true}
                    text={"Not checked & disabled"}
                />
            </div>
        </div>
    }

    rendeDropdowns(){
        const exmplValues = [
            {value: 1, text: "Arvo ABC"},
            {value: 2, text: "Arvo DEF"},
            {value: 3, text: "Arvo GHI"},
            {value: 4, text: "Arvo JKL"},
            {value: 5, text: "Arvo MNO"}
        ]
        const exmplValuesIcons = [
            {value: 1, text:"Arvo ABC", icon: "sliders"},
            {value: 2, text:"Arvo DEF", icon: "cancel"},
            {value: 3, text:"Arvo GHI", icon: "times"},
            {value: 4, text:"Arvo JKL", icon: "list"},
            {value: 5, text:"Arvo MNO", icon: "table"}
        ]

        return <div className={"grid-container grid-3"}>
            <DropdownMenu
                values={exmplValues}
                onSelect={(retVal)=>{
                    console.log(retVal)
                }}
                btnClass={"2nd"}
            />
            <DropdownMenu
                icon={"gear"}
                text={"Dropdown with icons"}
                values={exmplValuesIcons}
                onSelect={(retVal)=>{
                    console.log(retVal)
                }}
                btnClass={"2nd"}
            />
            <DropdownMenu
                values={exmplValuesIcons}
                currentValue={exmplValues[0].value}
                onSelect={(retVal)=>{
                    console.log(retVal)
                }}
                btnClass={"3rd"}
            />
        </div>
    }

    renderAccordions(){
        return <>
            <AccordionDropdown
                header={<h3>Accordion header</h3>}
            >
                <p>I am content</p>
            </AccordionDropdown>
            <Spacer/>
            <AccordionDropdown
                header={<h3>Accordion initiallyOpen</h3>}
                initiallyOpen={true}
            >
                <p>I am content</p>
            </AccordionDropdown>
            <Spacer/>
            <AccordionDropdown
                header={<h3>Accordion openDynamic & not closeable</h3>}
                dynamicOpen={true}
                closeable={false}
            >
                <p>I am content</p>
            </AccordionDropdown>
        </>
    }

    renderSpacers(){
        let sizes = ['sm', null, 'lg', 'xl']
        return <>
            {sizes.map((_size)=>{
                return <Spacer
                    key={"sp__" + _size}
                    size={_size}
                />
            })}
            {sizes.map((_size)=>{
                return <Spacer
                    key={"sp__ln__" + _size}
                    size={_size}
                    line={true}
                />
            })}
            {sizes.map((_size)=>{
                return <Spacer
                    key={"sp__ln__lbl__" + _size}
                    label={"Line " + (_size ? _size : " default")}
                    size={_size}
                    line={true}
                />
            })}
        </>
    }


    renderLoadingAnimations(){
        return <div className={"element-set"}>
            <div className={"element-set-v"}>
                <LoadingAnimation />
                <p>Default</p>
            </div>
            <div className={"element-set-v"}>
                <LoadingAnimation size={"lg"}/>
                <p>size="lg"</p>
            </div>
            <div className={"element-set-v"}>
                <LoadingAnimation text={"With text"} />
                <p>text="With text"</p>
            </div>
            <div className={"element-set-v"}>
                <LoadingAnimation color={"var(--color-2nd"} />
                <p>color="var(--color-2nd"</p>
            </div>
            <div className={"element-set-v"}>
                <LoadingAnimation type="arrows_mask" />
                <p>type="arrows_mask"</p>
            </div>
            <div className={"element-set-v"}>
                <LoadingAnimation type="arrows_mask" bg={"var(--color-gray)"} />
                <p>type & bg="var(--color-gray)"</p>
            </div>
        </div>
    }

    renderTextInputs(){
        return <>
            <div className={"grid-container grid-3"}>
                <TextInput
                    label={"Text input"}
                    placeholder={"Text input"}
                    onChange={(val)=> console.log(val)}
                />
                <TextInput
                    label={"Text input sm"}
                    placeholder={"Text input sm"}
                    size={"sm"}
                    onChange={(val)=> console.log(val)}
                />
                <TextInput
                    label={"Text input (required)"}
                    placeholder={"Text input (required)"}
                    required
                    onChange={(val)=> console.log(val)}
                />
                <TextInput
                    label={"Text input (required & valid)"}
                    placeholder={"Text input (required & valid)"}
                    required
                    isValid
                    value={"Set value"}
                    onChange={(val)=> console.log(val)}
                />
                <TextInput
                    label={"Text input with submit button"}
                    placeholder={"Write here and buttons shows up"}
                    onChange={(val)=> console.log(val)}
                    onSubmit={(val)=> console.log(val)}
                />
            </div>
            <Spacer/>
            <div className={"grid-container grid-3"}>
                <TextInput
                    placeholder={"Text input type search"}
                    type={"search"}
                    onChange={(val)=> console.log(val)}
                />
            </div>
        </>
    }

    renderContentDefault() {
        return <div className={"content content-styleguide"}>
            <div className={"slab sg-buttons"}>
                <h2>Buttons & button sets</h2>
                {this.renderButtons()}
            </div>
            <div className={"slab"}>
                <h2>Text inputs</h2>
                {this.renderTextInputs()}
            </div>
            <div className={"slab"}>
                <h2>Inputs</h2>
                {this.renderInputs()}
            </div>
            <div className={"slab"}>
                <h2>Dropdowns</h2>
                {this.rendeDropdowns()}
            </div>
            <div className={"slab"}>
                <h2>Accordions</h2>
                {this.renderAccordions()}
            </div>
            <div className={"slab sg-spacers"}>
                <h2>Spacers</h2>
                {this.renderSpacers()}
            </div>
            <div className={"slab"}>
                <h2>LoadingAnimations</h2>
                {this.renderLoadingAnimations()}
            </div>
        </div>
    }

    render() {
        require("./assets/scss/Home.scss");
        require("./assets/scss/Styleguide.scss");//included here so it will not be included in rest of app
        if (this.state.isLoading) {
            return <LoadingAnimation size={"lg"} />
        }
        return <div ref={this.container} className="app">
                <div className={"sidebar open locked"}>
                    <div className="scrollpane-vertical">
                        <ProsSidebarTop />
                        <Spacer/>
                        <ul>
                            <li>
                                <BasicButton
                                    btnClass={"2nd"}
                                    label={"Elements"}
                                    selected={this.state.subpage === 'default'}
                                    action={(evt)=> {
                                        this.setState({
                                            subpage: 'default'
                                        })
                                    }}
                                />
                                <Spacer/>
                            </li>
                            <li>
                                <BasicButton
                                    btnClass={"2nd"}
                                    label={"Icons & colors"}
                                    selected={this.state.subpage !== 'default'}
                                    action={(evt)=>   {
                                        this.setState({
                                            subpage: 'other'
                                        })
                                    }}
                                />
                                <Spacer/>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={"main-container"}>
                    {this.renderHeader()}
                    <section className={"content content-styleguide"}>
                        {this.state.subpage === 'default'
                            ? this.renderContentDefault() : this.renderContentOther()}
                    </section>
                </div>
                {this.loadingScreen()}
            </div>
    }
}

